import Api from '../../Api';

/* eslint-disable no-underscore-dangle */
export default class Editor {

    static _isEditMode = null;

    static _instance = null;

    static getInstance() {

        if (Editor._instance == null) {

            const editor = new Editor();
            editor.storage = {};
            editor.request = null;
            editor.version = 'v1';

            Editor._instance = editor;
        }

        return Editor._instance;
    }

    static isEditMode() {

        if (Editor._isEditMode === null) {
            
            Editor._isEditMode = false;

            if (document.querySelector('.js-editable-save'))
                Editor._isEditMode = true;

            if (window?.editable?.mode == 'edit') {

                Editor._isEditMode = true;
                Editor.getInstance().version = 'v2';
            }
        }

        return Editor._isEditMode;
    }

    get(name, storageClassName, storageId) {

        return new Promise((resolve) => {

            if (this.storage[storageClassName] != undefined)

                // already loaded
                resolve(this.storage[storageClassName][name] ?? null);

            else

                // load from site
                this
                    .load(storageClassName, storageId)
                    .then(() => resolve(this.storage[storageClassName][name] ?? null));

        });
    }

    static resetRequest() {

        return {
            pending: true,
            promise: null,
            context: {},
        };
    }

    load(storageClassName, storageId) {

        if (this.request == null) {

            const request = Editor.resetRequest();
            request.promise = new Promise((resolve) => {

                const intervalId = setInterval(() => {

                    if (!request.pending) {

                        clearInterval(intervalId);
                        delete this.request;

                        this
                            .realLoad(request)
                            .then(() => resolve());
                    }
                    else {

                        request.pending = false;
                        // run by next time
                    }

                }, 500);
            });

            this.request = request;
        }

        if (this.request.context[storageClassName] == undefined) {

            this.request.pending = true;
            this.request.context[storageClassName] = {
                className: storageClassName,
                id: storageId,
            };
        }

        return this.request.promise;
    }

    realLoad(request) {

        return new Promise((resolve) => {

            Api
                .fetch(`${Api.origin}/api/v1/site/storage.json`, { request: request.context })
                .then((response) => {

                    Object
                        .entries(response)
                        .forEach(([className, properties]) => {

                            this.storage[className] = properties;
                        });

                    resolve();
                });
        });
    }

}